// extracted by mini-css-extract-plugin
module.exports = {"Form":"styles_Form__jNZbC","heading":"styles_heading__JZsYw","formWrapper":"styles_formWrapper__2DEwy"};